<template>
  <AccountIconWh104 :image-url="imageUrl" />
</template>

<script>
import profile from '../../../../images/styleguide/IMG_1809.png'
import AccountIconWh104 from '../../components/atoms/account_icons/AccountIconWh104.vue'
export default {
  components: { AccountIconWh104 },
  data() {
    return {
      imageUrl: ''
    }
  },
  mounted() {
    this.imageUrl = profile
  }
}
</script>
